import { Callout } from './components/callout.tsx'
import { Xcelera } from './components/xcelera.tsx'

export const meta = () => [
	{ title: 'Getting Started · xcelera docs' },
	{
		name: 'description',
		content:
			'Add your first page and get an audit plus an AI diagnosis of what to fix, in a few minutes.',
	},
]

# Getting Started

<Xcelera /> audits your pages and diagnoses what to fix. Add a page now and in a
few minutes you'll have your first audit and an AI diagnosis of the change that
will improve performance the most. The free tier needs no credit card and covers
a daily audit for a full month.

## Add your page

Sign up, click **Add Page**, and enter the URL you care about most. Your
homepage is a good default.

The defaults suit most sites: a mobile device profile and a daily audit at 9am
in your timezone. Everything can be changed later, so don't agonize here. When
you're ready to dig into the options, [Regions & Devices](/docs/regions-and-devices)
and [Scheduling](/docs/scheduling) cover them.

<Callout type="info">
	Auditing a page behind a login? Flip **Requires authentication**. Those pages
	are audited via the API or CLI instead of on a schedule. See [Secure
	Pages](/docs/secure-pages).
</Callout>

## Watch your first audit

Leave **Run first audit now** switched on. The audit starts the moment you
click **Add Page**, and you land on its page to watch it complete. An audit
takes a few minutes: your page is measured from a dedicated machine under
controlled lab conditions, so the result is stable enough to act on. The
report covers your Lighthouse scores and Core Web Vitals.
[Audit Stability](/docs/audit-stability) explains what makes the numbers
trustworthy.

## Read your diagnosis

Your first successful audit is diagnosed automatically. Shortly after the
audit finishes, the diagnosis appears on the same page: the change that will
actually move the needle for your page, backed by evidence from the audit's
own measurements. [AI Diagnosis](/docs/ai-diagnosis) covers everything it
looks at.

## Keep it running

One audit is a snapshot; the value compounds when they keep running. Leave the
daily schedule on and the dashboard builds a score history for the page. A
regression from a deploy shows up as a step in the trend instead of going
unnoticed, and patterns no single audit can reveal, like a server that only
slows down at certain hours, stand out within a week. Diagnoses get better
with history too: each one reads your past audits, so it can tell a chronic
problem from one unlucky load.

[Performance Monitoring](/docs/performance-monitoring) covers how to read the
trend.

## Next steps

- [AI Diagnosis](/docs/ai-diagnosis) — what the diagnosis looks at and how to run more
- [Concepts](/docs/concepts) — how pages, audits, and scores fit together
- [Scheduling](/docs/scheduling) — audit frequency, timing, and timezones
- [Usage & Billing](/docs/usage-and-billing) — what's free and what paid plans unlock
